import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';

const ClientStats = ({ stats, onOpenTotal }) => {
  const { t } = useTranslation();

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('ro-RO', {
      style: 'currency',
      currency: 'RON'
    })?.format(amount);
  };

  const statCards = [
    {
      id: 'total-clients',
      title: t('clients.stats.total'),
      value: stats?.totalClients,
      icon: 'Users',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      change: stats?.clientsChange,
      changeType: stats?.clientsChange >= 0 ? 'positive' : 'negative'
    },
    {
      id: 'active-clients',
      title: t('clients.stats.activeClients'),
      value: stats?.activeClients,
      icon: 'UserCheck',
      color: 'text-success',
      bgColor: 'bg-success/10',
      change: stats?.activeClientsChange,
      changeType: stats?.activeClientsChange >= 0 ? 'positive' : 'negative'
    },
    {
      id: 'new-clients',
      title: t('clients.stats.newThisMonth'),
      value: stats?.newClientsThisMonth,
      icon: 'UserPlus',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      change: stats?.newClientsChange,
      changeType: stats?.newClientsChange >= 0 ? 'positive' : 'negative'
    },
    {
      id: 'vip-clients',
      title: t('clients.stats.vip'),
      value: stats?.vipClients,
      icon: 'Crown',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      change: stats?.vipClientsChange,
      changeType: stats?.vipClientsChange >= 0 ? 'positive' : 'negative'
    },
    {
      id: 'total-revenue',
      title: t('clients.stats.totalRevenue'),
      value: formatCurrency(stats?.totalRevenue),
      icon: 'TrendingUp',
      color: 'text-success',
      bgColor: 'bg-success/10',
      change: stats?.revenueChange,
      changeType: stats?.revenueChange >= 0 ? 'positive' : 'negative'
    },
    {
      id: 'avg-spending',
      title: t('clients.stats.avgSpending'),
      value: formatCurrency(stats?.averageSpending),
      icon: 'DollarSign',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      change: stats?.avgSpendingChange,
      changeType: stats?.avgSpendingChange >= 0 ? 'positive' : 'negative'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-6">
      {statCards?.map((stat) => (
        <div
          key={stat?.id}
          className={`bg-background border border-border rounded-lg p-4 hover-elevate transition-all duration-200 ${
            stat?.id === "total-clients" && onOpenTotal ? "cursor-pointer" : ""
          }`}
          role={stat?.id === "total-clients" && onOpenTotal ? "button" : undefined}
          tabIndex={stat?.id === "total-clients" && onOpenTotal ? 0 : undefined}
          onClick={() => {
            if (stat?.id === "total-clients") onOpenTotal?.();
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              if (stat?.id === "total-clients") onOpenTotal?.();
            }
          }}
        >
          <div className="flex items-center justify-between mb-3">
            <div className={`w-10 h-10 ${stat?.bgColor} rounded-lg flex items-center justify-center`}>
              <Icon name={stat?.icon} size={20} className={stat?.color} />
            </div>
            
            {stat?.change !== undefined && (
              <div className={`flex items-center space-x-1 text-xs ${
                stat?.changeType === 'positive' ? 'text-success' : 'text-error'
              }`}>
                <Icon 
                  name={stat?.changeType === 'positive' ? 'TrendingUp' : 'TrendingDown'} 
                  size={12} 
                />
                <span>{Math.abs(stat?.change)}%</span>
              </div>
            )}
          </div>
          
          <div className="space-y-1">
            <div className="text-2xl font-bold text-card-foreground">
              {stat?.value}
            </div>
            <div className="text-sm text-muted-foreground">
              {stat?.title}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ClientStats;